
import { map, startWith } from 'rxjs/operators';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ContractorService } from '../../services/contractor.service';
import { FileService } from '../../services/file.service';
import { FileTypeService } from '../../services/fileType.service';
import { NotificationService } from '../../services/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { FormControl } from "@angular/forms";
import { JobService } from "../../services/job.service";
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';

export interface FileNotification {
  topic: string;
  targetdate: string;
  frequency: string;
}

@Component({
  selector: 'new-file',
  templateUrl: './new-file.component.html',
  styleUrls: ['./new-file.component.scss']
})
export class NestasNewFileComponent implements OnInit {

  @Input() pid;
  @Input() editFile;
  @Input() originPIDId;

  sharing = {
    all: false
  };

  subPidSharing: any[] = [];

  @ViewChild('reuploadselect') reuploadselect: MatSelect;
  @ViewChild('uploadselect') uploadselect: MatSelect;

  working = false;
  newFile = null;
  reupload = [];
  upload = [];

  filesToUpload = [];
  newRoom = '';
  frequencies = [];
  notifications: FileNotification[] = [];
  fileUploadRowSpan = 3; // newFile.emailSent ? 4 : 3

  fileTypes;
  filteredFileTypes;
  filteredContractors;
  fileTypeControl: FormControl = new FormControl();

  acceptedFileMIMETYPE = 'application/x-compressed,application/x-zip-compressed,application/zip,multipart/x-zip,application/excel,application/msword,text/plain,application/postscript, */txt,*/zip,*/number,text/csv,text/html,application/msword,application/json,application/vnd.oasis.opendocument.presentation,application/vnd.oasis.opendocument.spreadsheet,application/vnd.oasis.opendocument.text,application/pdf,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/x-rar-compressed,application/rtf,image/gif,image/x-icon,image/jpeg,image/tiff,image/webp,image/svg+xml,image/png,application/x-tar,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/xml,application/x-7z-compressed';

  jobs;
  filteredJobs;
  jobControl: FormControl = new FormControl();
  contractorControl: FormControl = new FormControl();

  contractors = [];
  newContractor = {
    name: '',
    email: '',
    phone: ''
  };
  targetDatesModified = [];

  notrowspan = 1;

  isPhone = false;

  @Output() cancelled = new EventEmitter<Boolean>();
  @Output() completed = new EventEmitter<any>();

  constructor(private _fileService: FileService, private _jobService: JobService, private _contractorService: ContractorService,
    public translate: TranslateService, private _notification: NotificationService, private datePipe: DatePipe,
    private _router: Router, public fileTypeService: FileTypeService) {
  }

  ngOnInit() {
    console.log("new file oninit");
    this.isPhone = window.matchMedia('(max-width: 767px)').matches;
    this._reset();

    //  Setup fileType filtered list
    this.loadFileTypes();

    // Setup frequency list
    this.loadFrequencyTypes();

    //  Setup job filtered list
    this.loadJobs();

    //console.log("new file this.pid", this.pid, this.originPIDId);

    //  Sub pid reference for file sharing
    if (this.pid && this.pid.children && this.pid.children.display) {
      //console.log("full version", this.newFile.fullVersion);
      var datePerSubPid = [];
      if (this.newFile.fullVersion)
        datePerSubPid = this.newFile.fullVersion.reduce((ver, curr) => {
          if (!ver[curr.PID]) ver[curr.PID] = []; //If this type wasn't previously stored
          ver[curr.PID].push(curr);
          return ver;
        }, {});

      console.log(datePerSubPid);
      this.subPidSharing = _.map(this.pid.children.display, subPid => {
        let version = datePerSubPid[subPid._id.toString()];

        return {
          id: subPid._id,
          name: subPid.name,
          version: version && version.slice(-1)[0].date,
          sharedWith: this.editFile && _.indexOf(this.editFile.sharing || [], subPid._id) > -1
        };
      });

      this.sharing.all = _.every(this.subPidSharing, sharing => {
        return sharing.sharedWith;
      });
    }

    this._initNotificationsWrapper();
  }

  selectAll() {
    _.forEach(this.subPidSharing, sharing => {
      sharing.sharedWith = this.sharing.all;
    });
  }


  loadFileTypes(): void {

    this.fileTypeService.getMe()
      .subscribe(result => {
        this.fileTypes = result;
        //noinspection TypeScriptValidateTypes
        this.filteredFileTypes = this.fileTypeControl.valueChanges.pipe(
          startWith(null),
          map(val => val && val.length >= 2 ? this.autocompleteFilter(this.fileTypes, val) : this.fileTypes.slice(0, 0)));
      });
  }

  loadFrequencyTypes(): void {
    this.frequencies = ['REPEAT_NOT', '5 YEARLY', '2 YEARLY', 'YEARLY', '6MONTHLY', '3MONTHLY', 'MONTHLY', 'WEEKLY', 'DAYLY'];
  }

  loadJobs(): void {
    this._jobService.getMe()
      .subscribe((result: any) => {
        this.jobs = result;
        this.filteredJobs = [];
        //noinspection TypeScriptValidateTypes
        this.filteredJobs = this.jobControl.valueChanges.pipe(
          startWith(null),
          map(val => val && val.length >= 2 ? this.autocompleteFilter(this.jobs, val) : this.jobs.slice(0, 0)));
      });
  }

  autocompleteFilter(list, val: string) {
    return list.filter(option => option.value.toLowerCase().indexOf(val.toLowerCase()) > -1);
  }

  getContractorInfo() {
    if (this.newFile.contractor == "") {
      return this.newContractor;
    }
    return (_.find(this.contractors, c => {
      return (this.formatContractor(c) == this.newFile.contractor);
    }) || {});
  }

  fileIsEditable() {
    // shared distinct is not editable from subpid
    if (this.newFile.sharingType == 'distinct' && this.originPIDId && this.originPIDId != this.pid._id) {
      //console.log("editable", this.file.PID._id, this.originPIDId, "copy", this.file.PID.copy, "ro", this.file.readOnly, "locked", this.file.locked);
      //console.log("fileiseditable", this.originPIDId, this.pid._id, false);

      return false;
    }
    //console.log("fileiseditable", this.originPIDId, this.pid._id, true);

    return true;
  }

  getContractorRowHeight(row) {
    if (this.isPhone) {
      if (row == 1) {
        return 95;
      } else {
        return 65;
      }
    }
    if (row == 2) {
      return 55;
    }
    return 75;
  }


  addNotification() {
    var not = { topic: '', targetdate: this.datePipe.transform(new Date(), 'yyyy-MM-dd'), frequency: 'YEARLY' };
    //this.notrowspan += 3;
    this.notifications.push(not);
  }


  latestFiles() {
    if (this.newFile && this.newFile.version && this.newFile.version.length) {
      let latest = this.newFile.version.slice(-1)[0];
      if (latest.converted) {
        latest = this.newFile.version.slice(-2)[0];
      }
      return latest.files || [];
    }
    return [];
  }

  // supports both adding and editing a file
  addFile() {
    console.log("new file add file");
    this.working = true;
    var _self = this;
    var done = 0;

    //  Get file type
    this.newFile.type = this.fileTypeControl.value;

    //  Get file job
    this.newFile.job = this.jobControl.value;

    //  Basic parameters
    var params = _.merge(this.newFile, { newRoom: this.newRoom }, { newContractor: this.newContractor }, { files: [] });

    params.notifications = _.map(_.filter(this.notifications, r => {
      return r.topic.length > 0;
    }), r => {
      return ({ topic: r.topic, targetdate: r.targetdate, frequency: r.frequency });
    });

    this.notifications = params.notifications;
    if (this.editFile) {
      this.editFile.notifications = this.notifications;
    }

    // new files
    if (this.filesToUpload && this.filesToUpload.length > 0) {
      params.files = this.filesToUpload.filter((x, i) => this.upload.indexOf(i) > -1).map(x => {
        return ({ type: x.file.type, name: x.file.name });
      });
    }

    // reupload existing files
    if (this.reupload && this.reupload.length > 0) {

      let availableFiles = this.latestFiles();
      params.reupload = [];
      for (let i in this.reupload) {
        if (this.reupload[i]) {
          //let av = availableFiles[i];
          //params.reupload.push(av._id);
          params.reupload.push(this.reupload[i]);
        }
      }
      console.log("reupload", this.reupload, params.reupload, availableFiles);
    }

    //  Sub PID sharing
    params.subPIDsharing = this.subPidSharing;

    // update target or not
    params.targetDatesModified = this.targetDatesModified;

    if (this.newFile.contractor == "") {
      params.contractor = -1;
    } else {
      //console.log("contractors find", this.contractors);
      params.contractor = this.contractors.find(c => {
        return (this.formatContractor(c) === this.newFile.contractor);
      });
      if (params.contractor) {
        params.contractor = params.contractor._id;
      } else {
        params.contractor = -1;
      }
    }
    if (this.editFile)
      this.editFile.contractor = this.newFile.contractor;

    console.log("add file", this.reupload.length, this.reupload);
    this._fileService.addFile(this.pid._id, params, this.originPIDId)
      .subscribe((ret: any) => {
        console.log("add file done", ret);

        if (this.editFile) {
          this.editFile.sharingType = this.newFile.sharingType;
          this.editFile.providedByContractor = this.newFile.providedByContractor;
          this.newFile.contractor = this.editFile.contractor;
        }
        this.newFile.version = ret.version;
        if (ret.urls && ret.urls.length > 0) {
          var files = this.filesToUpload.filter((x, i) => this.upload.indexOf(i) > -1).map((x, i) => {
            return { file: x.file, url: ret.urls[i] };
          });
          _.forEach(files, (file) => {
            _self._fileService.uploadTo(file.url, file.file, ret.file._id)
              .finally(() => {
                ++done;
                if (done == files.length) {
                  _self._complete(ret.file);
                  _self._fileService.convertToPDF(ret.file._id).subscribe();
                  _self.working = false;
                }
              })
              .subscribe(
                success => {
                  _self._notification.success('NEW_FILE.FILE_UPLOADED', 'MESSAGE.SUCCESS');
                },
                err => {
                  _self._notification.errorCustom('NEW_FILE.FILE_UPLOADED', 'MESSAGE.ERROR.SERVER_ERROR_TITLE');
                }
              );
          })
        } else {
          if (ret.emailSent) {
            this._notification.info('MESSAGE.MAIL_SENT');
          } else {
            this._notification.info('MESSAGE.JOB_SAVED');
          }
          _self.working = false;
          _self._complete(ret.file);
        }
      },
        err => {
          this.working = false;
          this._notification.errorServer(err.err);
        }
      )
  }

  formatContractor(c) {
    if (!c || c == -1) return "()";
    return c.name + ' (' + c.email + ')';
  }

  private _reset(completed = false) {
    console.log("new file _reset", this.pid._id);
    this._contractorService.getMinePid(this.pid._id)
      .subscribe(
        (contractors: any) => {
          contractors = contractors.filter(x => !x.hidden).sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
          });
          this.contractors = contractors;
          var cts = []
          contractors.forEach(x => cts.push({ 'value': x.email + ' ' + x.name, '_id': x._id, 'name': x.name, 'email': x.email }));

          this.filteredContractors = this.contractorControl.valueChanges.pipe(
            startWith(null),
            map(val => val && val.length >= 1 ? this.autocompleteFilter(cts, val) : cts.slice(0, 0)));

          console.log("filtered contractors", this.filteredContractors);
        },
        this._notification.errorServer
      );
    this.filesToUpload = [];
    if (!this.editFile) {
      let today = new Date();
      this.newFile = {
        name: '',
        type: '',
        job: '',
        description: '',
        room: '',
        contractor: '',
        sharingType: 'shared',
        completion: [today.getFullYear(), today.getMonth() + 1 >= 10 ? today.getMonth() + 1 : "0" + (today.getMonth() + 1), today.getDate() >= 10 ? today.getDate() : "0" + (today.getDate())].join('-'),
        providedByContractor: true
      };
    } else if (this.editFile) {
      //console.log("edit file", this.editFile, this.newFile);
      if (this.newFile && this.newFile.notifications) {
        this.newFile.notifications = _.map(this.newFile.notifications, r => {
          let d = this.datePipe.transform(r.targetdate, 'yyyy-MM-dd');
          return ({ topic: r.topic, targetdate: d, frequency: r.frequency });
        });
        this.notifications = this.newFile.notifications;
      }

      if (!completed) {
        this.newFile = _.merge({}, this.editFile);
      }
      //console.log("new file", this.newFile);

      //console.log("setting reupload: versions", this.newFile && this.newFile.version || this.newFile, "latest version", this.latestFiles().map(x => x.fileID));
      if (this.latestFiles()) {
        this.reupload = [];
        for (let f of this.latestFiles()) {
          this.reupload.push(false);
        }
      }
      //console.log("resetting reupload done", this.reupload);


      if (this.editFile.contractor && typeof this.editFile.contractor == 'object') {
        this.newFile.contractor = this.formatContractor(this.editFile.contractor);
      } else {
        let c = this.contractors.find(c => {
          return (c._id == this.newFile.contractor);
        })
        this.newFile.contractor = this.formatContractor(c);
      }

      if (this.editFile.version && (this.editFile.version.date || this.editFile.version.length > 0)) {
        this.newFile.providedByContractor = false;
      }
      if (this.editFile.deadline) {
        let deadline = new Date(this.editFile.deadline);
        this.newFile.completion = [deadline.getFullYear(), deadline.getMonth() + 1 >= 10 ? deadline.getMonth() + 1 : "0" + (deadline.getMonth() + 1), deadline.getDate() >= 10 ? deadline.getDate() : "0" + (deadline.getDate())].join('-');
      }
    }
    if (!this.newFile.providedByContractor) {
      this.newFile.providedByContractor = false;
    }
    if (this.editFile) {
      this.newFile.sharingType = this.editFile.sharingType;
    }
    this.newRoom = "";
    this.newContractor = {
      name: '',
      email: '',
      phone: ''
    }

    this.updateFileUploadSpan();
  }

  private _initNotificationsWrapper() {
    this.notifications = _.map(this.newFile.notifications, (r: any) => {
      let d = this.datePipe.transform(r.targetdate, 'yyyy-MM-dd');
      return ({ topic: r.topic, targetdate: d, frequency: r.frequency });
    });
  }


  private _complete(file) {
    //file.version = file.version.length ? file.version[0] : null;
    if (this.editFile) {
      this.editFile.version = file.version;
    }

    this._reset(true);
    this.completed.emit(file);
  }

  indexTracker(index: number, value: any) {
    return index;
  }

  selectAllReUpload(i) {
    if (i) {
      this.uploadselect.options.forEach((item: MatOption, index: number) => {
        if (index == 0) item.deselect();
        if (index > 1) item.select();
      });
    } else {
      this.reupload = this.reupload.map(x => true);
      this.reuploadselect.options.forEach((item: MatOption, index: number) => {
        if (index == 0) item.deselect();
        if (index > 1) item.select();
      });
    }
  }

  selectNoneReUpload(i) {
    if (i) {
      this.uploadselect.options.forEach((item: MatOption) => item.deselect());
    } else {
      this.reupload = this.reupload.map(x => false);
      this.reuploadselect.options.forEach((item: MatOption) => item.deselect());
    }
  }

  updateFileUploadSpan() {
    //console.log("upload file upload span", this.newFile.providedByContractor, this.newFile.emailSent);
    if (this.newFile.providedByContractor) {
      this.fileUploadRowSpan = this.newFile.emailSent ? 4 : 3;
    } else {
      // newFile.emailSent ? 4 : 3
      //console.log(3 + Math.ceil(this.filesToUpload.length / 4) + Math.ceil(this.latestFiles().length / 4), 3, Math.ceil(this.filesToUpload.length / 4), Math.ceil(this.latestFiles().length / 4));
      this.fileUploadRowSpan = (this.newFile.version && this.newFile.version.length) ? this.filesToUpload.length ? 4 : 3 : this.filesToUpload.length ? 3 : 1;//+ Math.ceil(this.filesToUpload.length / 4) + Math.ceil(this.latestFiles().length / 4);
    }
  }

  uploadZoneHeight() {
    return this.filesToUpload.length ? '128px' : (this.newFile.version && this.newFile.version.length) ? '64px' : '32px';
  }

  fileChangeEvent(fileInput) {

    for (let f of fileInput.target.files) {
      this.filesToUpload.push({ upload: true, file: f });
      this.upload.push(this.filesToUpload.length - 1);
    }

    //console.log(this.filesToUpload);
    this.updateFileUploadSpan();
  }

  fileDropEvent(evt) {
    //console.log("allow file drop 1", evt);
    evt.preventDefault();
    evt.stopPropagation();
    evt.target.classList.remove('droparea');
    if (evt.dataTransfer.files) {
      let files: FileList = evt.dataTransfer.files;
      for (let f of evt.dataTransfer.files) {
        this.filesToUpload.push({ upload: true, file: f });
        this.upload.push(this.filesToUpload.length - 1);
      }
      this.updateFileUploadSpan();
    }
  }

  dragover(evt) {
    evt.target.classList.add('droparea');
    return false;
  }

  dragend(evt) {
    evt.target.classList.remove('droparea');
    return false;
  }

  targetdateChangeEvent(i, index) {
    if (this.targetDatesModified.indexOf(index) == -1) {
      this.targetDatesModified.push(index);
    }
  }

  updatingExistingContractor() {
    let c = _.find(this.contractors, c => {
      return c.email == this.newContractor.email;
    });

    return c ? (c.name != this.newContractor.name || c.phone != this.newContractor.phone) : false;
  }

  cancel($event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.cancelled.emit(true);
  }

  debug($event) {
    console.log("DEBUG:", $event);
  }

  goToSubPid(subPidId) {
    this._router.navigate(['file', this.newFile._id, subPidId]);
  }
}
